import React, { useEffect } from 'react';
import { selectActiveTab, selectIppicaRaceDetail } from 'features/ippica/selectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { BannerInformation } from 'components/bannerInformation';
import { IppicaLegenda } from '../ippicaLegenda';
import { IppicaNav } from '../ippicaNav';
import { IppicaNavMobile } from '../ippicaNavMobile';
import { IppicaNazioneDto } from 'types/swagger';
import { TabValue } from 'features/ippica/types';
import classNames from 'classnames';
import { isTruthy } from 'utility/functions';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import { setActiveTab } from 'features/ippica/ippicaSlice';
import styles from './IppicaInternalLayout.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import useWindowSize from 'hooks/useWindowSize';

export type IppicaInternalLayoutProps = {
  children?: React.ReactNode;
  noPaddingTop?: boolean;
  mieiIppodromi?: Array<IppicaNazioneDto>;
  ippicaNavToday?: Array<IppicaNazioneDto>;
  ippicaNavAntepost?: Array<IppicaNazioneDto>;
};

export const IppicaInternalLayout = ({ children, noPaddingTop, mieiIppodromi }: IppicaInternalLayoutProps) => {
  const dispatch = useAppDispatch();
  const isOpen = useTypedSelector(selectIsOpenCarrello);
  const { isMobile } = useWindowSize();

  const activeTab = useTypedSelector(selectActiveTab);
  const labelRisultati = useGetLabelByKey('risultati-e-partenti');
  const { isAntepost } = useTypedSelector(selectIppicaRaceDetail);

  useEffect(() => {
    if (!!activeTab) return;
    const nextItem = isTruthy(isAntepost) ? TabValue.ANTEPOST : TabValue.TODAY;
    dispatch(setActiveTab(nextItem));
  }, [isAntepost, activeTab, dispatch]);

  const objNav = <IppicaNav mieiIppodromi={mieiIppodromi} />;

  return (
    <div className={classNames(styles.container, { [styles.open]: isOpen, [styles.noPaddingTop]: noPaddingTop })}>
      <div className={styles.sidebar}>
        {isMobile ? (
          <IppicaNavMobile>{objNav}</IppicaNavMobile>
        ) : (
          <React.Fragment>
            {objNav}
            <div className={styles.linkWrapper}>
              <a href={`${process.env.NEXT_PUBLIC_IPPICA_RISULTATI_PARTENTI}`} className={styles.link} target="_blank">
                {labelRisultati}
              </a>
            </div>
            <IppicaLegenda />
          </React.Fragment>
        )}
      </div>

      <div className={styles.childrenContainer}>
        <BannerInformation
          text={'Non puoi giocare più di 10 esiti per avenimento'}
          type="warning"
          layoutType="big"
          visible={false}
        />
        {children}
      </div>
    </div>
  );
};
